import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component, computed, inject, signal } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";

import { FooterComponent } from "../../components/common/footer/footer";
import { NavigationComponent } from "../../components/common/navigation/navigation";
import { DialogDomainReportProblemComponent } from "../../components/dialogs/dialog-domain-report-problem/dialog-domain-report-problem";
import { DialogSendDiagnosticsComponent } from "../../components/dialogs/dialog-send-diagnostics/dialog-send-diagnostics";
import { AuthService } from "../../services/authservice";

@Component({
  selector: "page-support",
  templateUrl: "support.html",
  styleUrls: ["./support.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FooterComponent, NavigationComponent, TranslatePipe, AngularSvgIconModule],
})
export class SupportPage {
  private readonly dialog = inject(MatDialog);
  private readonly auth = inject(AuthService);
  protected lastErrorMessage = signal("");
  protected isErrorPresent = computed(() => this.lastErrorMessage() !== "");

  constructor() {
    this.auth.lastHttpError.subscribe((err) => {
      if (err.error?.detail) {
        this.lastErrorMessage.set(err.error.detail);
      } else {
        this.lastErrorMessage.set(err.message ?? "");
      }
    });
  }

  reportDomainsProblem(): void {
    this.dialog.open(DialogDomainReportProblemComponent, {});
  }

  reportProblem(): void {
    this.dialog.open(DialogSendDiagnosticsComponent, {});
  }
}
